/* eslint-disable camelcase */
import Vue from 'vue';
import GenericDialog from 'src/components/GenericDialog/GenericDialog';
export default function openDialog(genericDialogProps) {
    const node = document.createElement('div');
    document.body.appendChild(node);
    const vm = new Vue({
        el: node,
        name: 'GlobalGenericDialog',
        mounted() {
            if (this.$refs.dialog) {
                const genericDialogAccessor = this.$refs.dialog;
                genericDialogAccessor.open();
            }
        },
        render(h) {
            return h(GenericDialog, {
                ref: 'dialog',
                props: genericDialogProps
            });
        }
    });
    return vm.$children[0];
}
